import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import React, { forwardRef } from 'react';
import { getDefaultZIndex, em, rem, Global } from '@mantine/styles';
import { useAppShellContext } from '../AppShell.context.js';
import useStyles from './VerticalSection.styles.js';
import { getSortedBreakpoints } from '../HorizontalSection/get-sorted-breakpoints/get-sorted-breakpoints.js';
import { Box } from '../../Box/Box.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __getOwnPropSymbols(source)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
          _iterator2["return"]();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return target;
};

var VerticalSection = forwardRef(function (_a, ref) {
  var _b = _a,
      children = _b.children,
      className = _b.className,
      classNames = _b.classNames,
      styles = _b.styles,
      height = _b.height,
      _b$fixed = _b.fixed,
      fixed = _b$fixed === void 0 ? false : _b$fixed,
      _b$withBorder = _b.withBorder,
      withBorder = _b$withBorder === void 0 ? true : _b$withBorder,
      position = _b.position,
      zIndex = _b.zIndex,
      section = _b.section,
      unstyled = _b.unstyled,
      __staticSelector = _b.__staticSelector,
      variant = _b.variant,
      others = __objRest(_b, ["children", "className", "classNames", "styles", "height", "fixed", "withBorder", "position", "zIndex", "section", "unstyled", "__staticSelector", "variant"]);

  var ctx = useAppShellContext();

  var _zIndex = zIndex || ctx.zIndex || getDefaultZIndex("app");

  var _useStyles = useStyles({
    height: height,
    fixed: ctx.fixed || fixed,
    position: position,
    zIndex: typeof _zIndex === "number" && ctx.layout === "default" ? _zIndex + 1 : _zIndex,
    layout: ctx.layout,
    borderPosition: withBorder ? section === "header" ? "bottom" : "top" : "none"
  }, {
    name: __staticSelector,
    classNames: classNames,
    styles: styles,
    unstyled: unstyled,
    variant: variant
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx,
      theme = _useStyles.theme;

  var breakpoints = _typeof(height) === "object" && height !== null ? getSortedBreakpoints(height, theme).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        breakpoint = _ref2[0],
        breakpointSize = _ref2[1];

    acc["@media (min-width: ".concat(em(breakpoint), ")")] = _defineProperty({}, "--mantine-".concat(section, "-height"), rem(breakpointSize));
    return acc;
  }, {}) : null;
  return (
    /* @__PURE__ */
    React.createElement(Box, __spreadValues({
      component: section === "header" ? "header" : "footer",
      className: cx(classes.root, className),
      ref: ref
    }, others), children,
    /* @__PURE__ */
    React.createElement(Global, {
      styles: function styles() {
        return {
          ":root": __spreadValues(_defineProperty({}, "--mantine-".concat(section, "-height"), _typeof(height) === "object" ? rem(height == null ? void 0 : height.base) || "100%" : rem(height)), breakpoints)
        };
      }
    }))
  );
});
VerticalSection.displayName = "@mantine/core/VerticalSection";
export { VerticalSection };